import { Popover, Tooltip } from 'antd';
import React from 'react';
import ChangeBalanceForm from '../../ChangeBalanceForm';
import Icon from '@ant-design/icons/lib/components/Icon';
import { PlusCircleOutlined } from '@ant-design/icons';

function IncreaseBalance({ id, currency = "EUR" }) {
  return (
    <Tooltip placement="bottomRight" title="Increase balance" destroyTooltipOnHide>
      <Popover
        content={<ChangeBalanceForm type="increase" id={id} currency={currency} />}
        title="Increase balance"
        trigger="click"
        placement="topRight"
      >
        <PlusCircleOutlined color="black" />
        {/* <Icon type="plus-circle" className={['mr', className, 'cursor-pointer']} /> */}
      </Popover>
    </Tooltip>
  );
};

export default IncreaseBalance;
